import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAccessStatistics } from '@api/data-security';

export const getCoreDataSecurityAccessStatisticsSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAccessStatistics',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAccessStatistics,
	retainDataOnRequest: true
});
